import type { OrbitForgeSave } from "../save/types";

export function estimatedCreditsPerSecond(save: OrbitForgeSave): number {
  return save.stats.TotalEarnedCredits / Math.max(60, save.stats.TotalPlayTimeSeconds);
}

export function roundTimedReward(value: number): number {
  if (value < 10_000) {
    return Math.ceil(value / 10) * 10;
  }
  if (value < 1_000_000) {
    return Math.ceil(value / 100) * 100;
  }
  return Math.ceil(value / 1_000) * 1_000;
}

export function applyCountedCredits(save: OrbitForgeSave, credits: number): void {
  save.stats.Credits += credits;
  save.stats.TotalEarnedCredits += credits;
  save.stats.DailyEarnedCredits += credits;
  save.stats.WeeklyEarnedCredits += credits;
}
